import PropTypes from 'prop-types';
import { memo } from 'react';

import { IconButton } from '@mui/material';
import DOMPurify from 'dompurify';

import CloseIcon from '@mui/icons-material/Close';

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import moment from 'moment';

const PreviewModal = memo(({ onCloseModal, modalTitle, modalContent, modaldate }) => {
  return (
    <>
      <MDBox display="flex" justifyContent="space-between" alignItems="center">
        <MDTypography id="modal-modal-title" variant="h4" component="h2">
          {modalTitle}
        </MDTypography>
        <IconButton onClick={onCloseModal}>
          <CloseIcon fontSize="large" />
        </IconButton>
      </MDBox>
      <MDBox mt={3} display="flex" flexDirection="column" gap="16px">
        <div
          id="modal-modal-description"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(modalContent) ?? '',
          }}
        />
      </MDBox>
      <MDBox mt={3} display="flex" flexDirection="column" gap="16px">
      {moment(modaldate).format('DD/MM/YYYY h:mm a')}
      </MDBox>
    </>
  );
});

PreviewModal.propTypes = {
  onCloseModal: PropTypes.func,
  modalTitle: PropTypes.string,
  modalContent: PropTypes.any,
  modaldate:PropTypes.string,
};

PreviewModal.defaultProps = {
  onCloseModal: () => {},
  modalTitle: '',
  modalContent: '',
  modaldate: '',
};

export default PreviewModal;
